import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext.jsx";
import WelcomePage from "./pages/auth/WelcomePage";
import SuperAdminDashboard from "./pages/admin/dashboard/superAdminDashboard";
import CompanyPage from "./pages/admin/company/CompanyPage";
import CompanyDetailPage from "./pages/admin/company/CompanyDetailPage";
import AnnouncementsPage from "./pages/admin/announcements/AnnouncementPage";
import ProfilePage from "./pages/admin/profile/ProfilePage";
import ContactRequestPage from "./pages/admin/contactRequests/ContactRequestPage";
import BrandsPage from "./pages/admin/brands/BrandsPage";
import ReviewsPage from "./pages/admin/reviews/ReviewsPage";
import BlogsPage from "./pages/admin/blogs/BlogsPage";
import SettingsPage from "./pages/admin/settings/SettingsPage";
import AdminLayout from "./layouts/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { ROUTES } from "./routes/routes";
import { ToastContainer } from 'react-toastify';

const AppToastContainer = () => {
  const { isDark } = useTheme();

  return (
    <ToastContainer
      position="top-right"
      autoClose={500}
      hideProgressBar={true}
      theme={isDark ? "dark" : "light"}
    />
  );
};


function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.WELCOME} element={<WelcomePage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path={ROUTES.ADMIN_DASHBOARD} element={<SuperAdminDashboard />} />
            <Route path={ROUTES.ADMIN_COMPANY} element={<CompanyPage />} />
            <Route path={ROUTES.ADMIN_COMPANY_DETAILS} element={<CompanyDetailPage />} />
            <Route path={ROUTES.ADMIN_ANNOUNCEMENTS} element={<AnnouncementsPage />} />
            <Route path={ROUTES.ADMIN_PROFILE} element={<ProfilePage />} />
            <Route path={ROUTES.ADMIN_CONTACT_REQUESTS} element={<ContactRequestPage />} />
            <Route path={ROUTES.ADMIN_BRANDS} element={<BrandsPage />} />
            <Route path={ROUTES.ADMIN_REVIEWS} element={<ReviewsPage />} />
            <Route path={ROUTES.ADMIN_BLOG} element={<BlogsPage />} />
            <Route path={ROUTES.ADMIN_BLOGS} element={<BlogsPage />} />
            <Route path={ROUTES.ADMIN_SETTINGS} element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Navigate to={ROUTES.WELCOME} replace />} />
        </Routes>
        <AppToastContainer/>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
